import { Music4, Timer, ListMusic, Radio, Split, FileMusic, AudioWaveform, Leaf } from "lucide-react";

// Live performance & music production apps by Taurus Technology.
// App Store links are placeholders ("#") until the real URLs are provided.
export const APPS = [
  {
    id: "key-finder",
    name: "Key Finder",
    icon: Music4,
    tagline: "Find the key. Mix in harmony.",
    description:
      "Instantly detect the musical key and BPM of any track so you can build harmonically seamless sets and mash-ups on the fly.",
    tags: ["Mixing", "Harmonic"],
    appStore: "#",
  },
  {
    id: "my-timecode",
    name: "My Timecode",
    icon: Timer,
    tagline: "Lock your whole rig to the clock.",
    description:
      "Rock-solid SMPTE / MTC timecode generation and sync to keep playback, lighting, and video perfectly in step all night.",
    tags: ["Timecode", "Sync"],
    appStore: "#",
  },
  {
    id: "rhrsl",
    name: "RHRSL",
    icon: ListMusic,
    tagline: "Run tighter rehearsals.",
    description:
      "Share setlists, cues, arrangements, and notes with the whole band so every rehearsal moves faster and lands cleaner.",
    tags: ["Rehearsal", "Band"],
    appStore: "#",
  },
  {
    id: "live-link",
    name: "Live Link",
    icon: Radio,
    tagline: "Your stage, connected.",
    description:
      "Link and control your devices and apps in real time across the network — one tap to keep your entire live setup in sync.",
    tags: ["Networking", "Control"],
    appStore: "#",
  },
  {
    id: "gig-split",
    name: "Gig Split",
    icon: Split,
    tagline: "Fair pay, zero drama.",
    description:
      "Split gig earnings across the band in seconds with transparent, customizable shares and clean payout summaries.",
    tags: ["Payouts", "Band"],
    appStore: "#",
  },
  {
    id: "paper-pilot",
    name: "Paper Pilot",
    icon: FileMusic,
    tagline: "Go paperless on stage.",
    description:
      "Charts, lyrics, and scores that scroll hands-free and follow your set — leave the binder and music stand behind.",
    tags: ["Charts", "Hands-free"],
    appStore: "#",
  },
  {
    id: "clk-slt",
    name: "CLK / SLT",
    icon: AudioWaveform,
    tagline: "Click tracks & setlist automation.",
    description:
      "Drive in-ear click tracks and automate your setlist transitions so the whole show stays locked to the groove.",
    tags: ["Click", "Setlist"],
    appStore: "#",
  },
  {
    id: "greenroom",
    name: "Greenroom",
    icon: Leaf,
    tagline: "Wellness for life on the road.",
    description:
      "A wellness companion built for tour professionals — track sleep, recovery, hydration, and mental health, with routines that survive jet lag, late load-outs, and back-to-back show days.",
    tags: ["Wellness", "Touring"],
    appStore: "#",
  },
];

export const STATS = [
  { value: "8", label: "Pro Apps" },
  { value: "Live", label: "On Stage" },
  { value: "iOS", label: "App Store" },
  { value: "∞", label: "Performances" },
];
